import React from "react";
import "./buttonsolidlg.css";

const ButtonSolidLg = ({ text, buttonHandler,showLoader}) => {
  return (
    <button className="buttonsolidlg" onClick={buttonHandler}>
      {(showLoader) &&  <i   className="fa fa-spinner fa-spin " style={{color:"white",marginRight:"10px"}}></i> }
      {text}
    </button>
  );
};

export default ButtonSolidLg;
